module.exports = __webpack_public_path__ + "img/loading.19250cfc.gif";